import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface WeeklySchedule {
    id: number;
    isActive: boolean;
    endingDate: string;
    auditTrailId: number | null;
    startingDate: string;
    cookProfileId: number;
}

interface ApiResponse {
    data: {
        data: WeeklySchedule[];
        message: string;
        db_status: string;
    };
    isSuccess: boolean;
    status: number;
}

interface WeeklyScheduleState {
    data: WeeklySchedule[];
    loading: boolean;
    error: string | null;
}

const COOKPORT = import.meta.env.VITE_COOK_PORT;
const COOKURL = import.meta.env.VITE_API_COOK_URL;

export const customSearchWeeklySchedule = createAsyncThunk<
    WeeklySchedule[],
    { cookProfileId: any, isActive?: any },
    { rejectValue: string }
>(
    'customSearchWeeklySchedule/customSearchWeeklySchedule',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<ApiResponse>(
                'custom_search_weekly_schedule',
                COOKPORT,
                COOKURL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            console.error('API Error:', error);
            return rejectWithValue(error.message || 'Failed to fetch weekly schedules');
        }
    }
);
export const customSearchWeeklyScheduleSlice = createSlice({
    name: 'customSearchWeeklySchedule',
    initialState: {
        data: [] as WeeklySchedule[],
        loading: false,
        error: null,
    } as WeeklyScheduleState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(customSearchWeeklySchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                customSearchWeeklySchedule.fulfilled,
                (state, action: PayloadAction<WeeklySchedule[]>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(customSearchWeeklySchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch weekly schedules';
            });
    },
});

export default customSearchWeeklyScheduleSlice.reducer;